var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29104",
    "data-name": "Group 29104",
    transform: "translate(-2866.979 -756.979)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1023",
    "data-name": "Ellipse 1023",
    transform: "translate(2866.979 756.979)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29103",
    "data-name": "Group 29103",
    transform: "translate(2871.185 761.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65291",
    "data-name": "Path 65291",
    d: "M2874.73,764.941l-3.584,3.584",
    transform: "translate(-2871.146 -764.94)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65292",
    "data-name": "Path 65292",
    d: "M3.584,0,0,3.584",
    transform: "translate(3.584 0) rotate(90)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffline);
export default __webpack_public_path__ + "static/media/offline.fd64c090fbd2da1ba986f7950916176c.svg";
export { ForwardRef as ReactComponent };